module.exports = __webpack_public_path__ + "static/media/view-360-circle.4a2337bb.png";